import { render, staticRenderFns } from "./OrderToday.vue?vue&type=template&id=3b22d58b"
import script from "./OrderToday.vue?vue&type=script&lang=js"
export * from "./OrderToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports